import { createSlice } from "@reduxjs/toolkit";
import { getinventoryCostAnalysisFilteredData, getinventoryCostAnalysisReportList, resetinventoryCostAnalysisFilteredData } from "./../services/inventoryCostAnalysisServices";


let initialState = {
  isLoading: false,
  pages: 0,
  errors: null,

  data: [],
  // Filter data
  filteredData : []
};

const inventoryCostAnalysis = createSlice({
  name: "inventoryCostAnalysis",
  initialState,
  extraReducers: (builder) => {

  /* -------------------------------------------- Get CostAdjustment Reports List ------------------------------------ */
    builder.addCase(getinventoryCostAnalysisReportList.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getinventoryCostAnalysisReportList.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = (payload[0] && JSON.parse(payload[0].jsonData)) || null;
      state.errors = null;
    })
    builder.addCase(getinventoryCostAnalysisReportList.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })

   /* --------------------------------------------------------------------------------------------------- */
 /* --------------------------------------- Menu Engineering Filter Data ------------------------------*/
    builder.addCase(getinventoryCostAnalysisFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(getinventoryCostAnalysisFilteredData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.filteredData = payload;
      state.errors = null;
    });
    builder.addCase(getinventoryCostAnalysisFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
   /* -------------------------------------------------------------------------------------- */
    builder.addCase(resetinventoryCostAnalysisFilteredData.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(resetinventoryCostAnalysisFilteredData.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.filteredData = [];
      state.errors = null;
    });
    builder.addCase(resetinventoryCostAnalysisFilteredData.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
   /* --------------------------------------------------------------------------------------------------- */
  }
});

export default inventoryCostAnalysis.reducer;